import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioArch } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH: TIdToPageConfigMap = {
  [PageIdStylioArch.AGE_ARCH]: {
    id: PageIdStylioArch.AGE_ARCH,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioArch.SHOP_SMARTER_ARCH]: {
    id: PageIdStylioArch.SHOP_SMARTER_ARCH,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioArch.HAIR_COLOR_ARCH]: {
    id: PageIdStylioArch.HAIR_COLOR_ARCH,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WARDROBE_COLORS_ARCH]: {
    id: PageIdStylioArch.WARDROBE_COLORS_ARCH,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.COLOR_CONFIDENCE_ARCH]: {
    id: PageIdStylioArch.COLOR_CONFIDENCE_ARCH,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.EYES_COLOR_ARCH]: {
    id: PageIdStylioArch.EYES_COLOR_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SKIN_COLOR_ARCH]: {
    id: PageIdStylioArch.SKIN_COLOR_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.CLIMAT_ARCH]: {
    id: PageIdStylioArch.CLIMAT_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.BODY_SHAPE_ARCH]: {
    id: PageIdStylioArch.BODY_SHAPE_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.BODY_SHAPE_CONFIDENCE_ARCH]: {
    id: PageIdStylioArch.BODY_SHAPE_CONFIDENCE_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SHOW_OFF_FEATURES_ARCH]: {
    id: PageIdStylioArch.SHOW_OFF_FEATURES_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.STYLIO_TO_HELP_ARCH]: {
    id: PageIdStylioArch.STYLIO_TO_HELP_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.MAIN_GOAL_ARCH]: {
    id: PageIdStylioArch.MAIN_GOAL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioArch.WHERE_TO_SHOP_ARCH]: {
    id: PageIdStylioArch.WHERE_TO_SHOP_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WARDROBE_PERCENTAGE_ARCH]: {
    id: PageIdStylioArch.WARDROBE_PERCENTAGE_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.URGE_1_ARCH]: {
    id: PageIdStylioArch.URGE_1_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_2_ARCH]: {
    id: PageIdStylioArch.URGE_2_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_3_ARCH]: {
    id: PageIdStylioArch.URGE_3_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_9_ARCH]: {
    id: PageIdStylioArch.URGE_9_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_4_ARCH]: {
    id: PageIdStylioArch.URGE_4_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_5_ARCH]: {
    id: PageIdStylioArch.URGE_5_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_6_ARCH]: {
    id: PageIdStylioArch.URGE_6_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.STYLE_PROFILE_ARCH]: {
    id: PageIdStylioArch.STYLE_PROFILE_ARCH,
  },
  [PageIdStylioArch.WARDROBE_READY_ARCH]: {
    id: PageIdStylioArch.WARDROBE_READY_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.URGE_7_ARCH]: {
    id: PageIdStylioArch.URGE_7_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.URGE_8_ARCH]: {
    id: PageIdStylioArch.URGE_8_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.STYLE_DRAWN_TO_ARCH]: {
    id: PageIdStylioArch.STYLE_DRAWN_TO_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.OUTFIT_EMOTION_ARCH]: {
    id: PageIdStylioArch.OUTFIT_EMOTION_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.STYLE_DISCOVERY_ARCH]: {
    id: PageIdStylioArch.STYLE_DISCOVERY_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.NOTHING_TO_WEAR_ARCH]: {
    id: PageIdStylioArch.NOTHING_TO_WEAR_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.ARCHETYPE_INTRO_ARCH]: {
    id: PageIdStylioArch.ARCHETYPE_INTRO_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.DRESSED_FEEL_ARCH]: {
    id: PageIdStylioArch.DRESSED_FEEL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.STYLE_MATTERS_MOST_ARCH]: {
    id: PageIdStylioArch.STYLE_MATTERS_MOST_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.OUTFIT_VIBE_ARCH]: {
    id: PageIdStylioArch.OUTFIT_VIBE_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.OUTFIT_COMPLIMENT_ARCH]: {
    id: PageIdStylioArch.OUTFIT_COMPLIMENT_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SHOP_PULLS_FIRST_ARCH]: {
    id: PageIdStylioArch.SHOP_PULLS_FIRST_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.ARCHETYPE_LOADING_ARCH]: {
    id: PageIdStylioArch.ARCHETYPE_LOADING_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.ARCHETYPE_RESULT_ARCH]: {
    id: PageIdStylioArch.ARCHETYPE_RESULT_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.LOOKING_FEMININE_ARCH]: {
    id: PageIdStylioArch.LOOKING_FEMININE_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.STYLES_FEEL_LIKE_YOU_ARCH]: {
    id: PageIdStylioArch.STYLES_FEEL_LIKE_YOU_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.TALL_ARCH]: {
    id: PageIdStylioArch.TALL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WEIGHT_ARCH]: {
    id: PageIdStylioArch.WEIGHT_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WARDROBE_CHANGED_ARCH]: {
    id: PageIdStylioArch.WARDROBE_CHANGED_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.FAVORITE_COLORS_ARCH]: {
    id: PageIdStylioArch.FAVORITE_COLORS_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_11_ARCH]: {
    id: PageIdStylioArch.LIKE_OR_DISLIKE_11_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_14_ARCH]: {
    id: PageIdStylioArch.LIKE_OR_DISLIKE_14_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_15_ARCH]: {
    id: PageIdStylioArch.LIKE_OR_DISLIKE_15_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_18_ARCH]: {
    id: PageIdStylioArch.LIKE_OR_DISLIKE_18_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_19_ARCH]: {
    id: PageIdStylioArch.LIKE_OR_DISLIKE_19_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WALK_INTO_ROOM_ARCH]: {
    id: PageIdStylioArch.WALK_INTO_ROOM_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.PERFECT_WEEKEND_ARCH]: {
    id: PageIdStylioArch.PERFECT_WEEKEND_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WARDROBE_FEEL_ARCH]: {
    id: PageIdStylioArch.WARDROBE_FEEL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SHOPPING_ARCH]: {
    id: PageIdStylioArch.SHOPPING_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SHOPPING_BUDGET_ARCH]: {
    id: PageIdStylioArch.SHOPPING_BUDGET_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.SHOPPING_PRIORITY_ARCH]: {
    id: PageIdStylioArch.SHOPPING_PRIORITY_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.CURATED_LINKS_ARCH]: {
    id: PageIdStylioArch.CURATED_LINKS_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIFESTYLE_FOCUS_ARCH]: {
    id: PageIdStylioArch.LIFESTYLE_FOCUS_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.OUTFIT_NEEDS_ARCH]: {
    id: PageIdStylioArch.OUTFIT_NEEDS_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.WARDROBE_ALIGNS_ARCH]: {
    id: PageIdStylioArch.WARDROBE_ALIGNS_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.LIFESTYLE_CHANGES_ARCH]: {
    id: PageIdStylioArch.LIFESTYLE_CHANGES_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.AMAZON_FRUSTRATION_ARCH]: {
    id: PageIdStylioArch.AMAZON_FRUSTRATION_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArch.PREPARE_FLOW_ARCH]: {
    id: PageIdStylioArch.PREPARE_FLOW_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.EMAIL_ARCH]: {
    id: PageIdStylioArch.EMAIL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.EMAIL_CONSENT_ARCH]: {
    id: PageIdStylioArch.EMAIL_CONSENT_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.NAME_ARCH]: {
    id: PageIdStylioArch.NAME_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.READINESS_LEVEL_ARCH]: {
    id: PageIdStylioArch.READINESS_LEVEL_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.PRE_PAYWALL_OFFER_ARCH]: {
    id: PageIdStylioArch.PRE_PAYWALL_OFFER_ARCH,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArch.SUBSCRIPTIONS_ARCH]: {
    id: PageIdStylioArch.SUBSCRIPTIONS_ARCH,
  },
  [PageIdStylioArch.CANCEL_OFFER_ARCH]: {
    id: PageIdStylioArch.CANCEL_OFFER_ARCH,
  },
  [PageIdStylioArch.SUB_UPSELL_ARCH]: {
    id: PageIdStylioArch.SUB_UPSELL_ARCH,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch.UPSELL_ARCH]: {
    id: PageIdStylioArch.UPSELL_ARCH,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch.DOWNLOAD_ARCH]: {
    id: PageIdStylioArch.DOWNLOAD_ARCH,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
